import React from 'react';

import { capitalize } from '@utils/format';

import { UserStatus } from 'generated/types';

import Chip from '../../UniversalChip';

interface UserStatusChipProps {
  status: UserStatus;
}

export default function UserStatusChip({ status }: UserStatusChipProps) {
  let color = '';
  switch (status) {
    case UserStatus.new:
      color = 'warning.main';
      break;
    case UserStatus.invited:
      color = 'warning.dark';
      break;
    case UserStatus.active:
      color = 'success.main';
      break;
    case UserStatus.disabled:
      color = 'text.secondary';
      break;
    case UserStatus.cancelled:
      color = 'error.main';
      break;
  }

  return <Chip color={color} label={capitalize(status)} type="secondary" />;
}
